
const s3ImageStorageUrl = 'https://s3.ap-southeast-2.amazonaws.com/wonderinghowto.com'
const s3prefixUrl = {
    awsImagePath: s3ImageStorageUrl + '/aws-images',
    gifPath: s3ImageStorageUrl + '/gif'
}

export default s3prefixUrl;
